var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"image_button",class:{'is_selected': _vm.selected},on:{"click":_vm.clickButton}},[_c('div',{staticClass:"img_part",class:_vm.buttonView.class}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.buttonView.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }